<template>
  <div class="tab-content">
    <network-diagram />

    <div class="network-tab-tools-container">
      <network-starting-point
        @submit="getNetworkDiagram"
        :disabled="calculationsAreRunning"
      />

      <calculations @updateRunState="calculationsAreRunning = $event" />
    </div>

    <network-diagram-object-menu v-if="isObjectMenuOpen" />

    <network-diagram-zoom-in v-if="isZoomInOpen && hasTechnicalLocalSelected" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Calculations from "./Calculations/Calculations";
import NetworkDiagram from "./NetworkDiagram/NetworkDiagram";
import NetworkStartingPoint from "../StartingPoint/StartingPoint";
import NetworkDiagramZoomIn from "./NetworkDiagramZoomIn";
import NetworkDiagramObjectMenu from "./ObjectMenu/ObjectMenu";

export default {
  name: "NetworkTab",

  components: {
    NetworkDiagramObjectMenu,
    NetworkDiagramZoomIn,
    NetworkStartingPoint,
    NetworkDiagram,
    Calculations
  },

  data() {
    return {
      calculationsAreRunning: false
    };
  },

  computed: {
    ...mapGetters({
      hasTechnicalLocalSelected: "isNetworkDiagramStartingPointSelected",
      isZoomInOpen: "isNetworkDiagramZoomInOpen",
      isObjectMenuOpen: "isNetworkDiagramObjectMenuOpen"
    }),

    workspaceUUID() {
      let workspaceUUID = this.$store.getters.getNetworkDiagramWorkspaceUUID;
      if (!workspaceUUID) {
        workspaceUUID = this.$store.getters.workspace.uuid;
      }
      return workspaceUUID;
    }
  },

  methods: {
    ...mapActions([
    "GET_NETWORK_DIAGRAM_DATA",
    "GET_NETWORK_DIAGRAM_DATA_FROM_CLOSURE",
    "SET_NETWORK_DIAGRAM_TECHNICAL_LOCAL_UUID",
    "SET_NETWORK_DIAGRAM_CLOSURE_UUID"
    ]),

    getNetworkDiagram(technicalLocalUUID, closureUUID, filteringMethod) {
      if (closureUUID === undefined) {
        this.SET_NETWORK_DIAGRAM_CLOSURE_UUID(closureUUID);
        this.GET_NETWORK_DIAGRAM_DATA({
        nodeUUID: technicalLocalUUID,
        workspaceUUID: this.workspaceUUID
      }).then(() => { filteringMethod()}).catch(error => {
        this.$toasted.global.toast_error(error);
      });
      } else {
        this.SET_NETWORK_DIAGRAM_CLOSURE_UUID(closureUUID);
        this.GET_NETWORK_DIAGRAM_DATA_FROM_CLOSURE({
          nodeUUID: closureUUID,
          workspaceUUID: this.workspaceUUID
        }).catch(error => {
          this.$toasted.global.toast_error(error);
        });
        
        if (!technicalLocalUUID) {
          this.SET_NETWORK_DIAGRAM_TECHNICAL_LOCAL_UUID("Technical Local");
        }
      }
    }
  }
};
</script>

<style scoped>
.tab-content {
  position: relative;
  width: 100%;
  height: calc(100% - 7px);
  background-color: white;
}
.network-tab-tools-container {
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Network/NetworkTab.vue